import '../../App.css';
import React, { useState, useRef } from "react";
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import "./KitsArduino.css";
import {useNavigate} from "react-router-dom";

// Main components object
const componentes = {
    
    
    "UNO R3": {
        image: "/images/Kits/UNOR3.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "1 Protoboard grande": {
        image: "/images/Kits/proto.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "20 Jumpers Macho-Hembra": {
        image: "/images/Kits/MH.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "20 Jumpers Macho-Macho": {
        image: "/images/Kits/jumpers.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "10 Leds de colores": {
        image: "/images/Kits/leds.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "15 Resistencias": {
        image: "/images/Kits/resistencia.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "5 botones pulsadores": {
        image: "/images/Kits/boton.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "1 buzzer": {
        image: "/images/Kits/buzzer.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "1 Pantalla LCD con i2c": {
        image: "/images/Kits/pantalla.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "1 tilt sensor": {
        image: "/images/Kits/Tilt.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "1 Sensor sorpresa": {
        image: "/images/Kits/sorpresa.png",
    },
};

// New constant for the Ultimate kit components (5 items)
const componentesUltimate = {
    "3 Dip Switches": {
        image: "/images/Kits/dip.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "Adaptador de corriente": {
        image: "/images/Kits/corriente.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "Joystick": {
        image: "/images/Kits/joystick.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "Sensor ultrasónico": {
        image: "/images/ultra.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
    "Servomotor": {
        image: "/images/Kits/Servomotor.jpg",
        description: "A protoboard is used to build and test circuits without soldering."
    },
};

// Surprise components (sorpresa)
const sorpresa = {
    "Motor Stepper": "/images/Kits/Sorpresa/stepper.jpg",
    "Keypad": "/images/Kits/Sorpresa/keypad.jpg",
    "Sensor de temperatura y humedad": "/images/Kits/Sorpresa/humedad.jpg",
    "Módulo Bluetooth": "/images/Kits/Sorpresa/bluetooth.jpg",
    "Sensor infrarrojo": "/images/Kits/Sorpresa/infrarrojo.jpg",
    "PIR": "/images/Kits/Sorpresa/pir.jpg",
    "Modulo de doble rele": "/images/Kits/Sorpresa/rele.jpg",
    "Control infrarrojo": "/images/Kits/Sorpresa/control.jpg",
    "Motor TT": "/images/Kits/Sorpresa/motor.jpg",
};

const KitsArduino = () => {
    const continueButtonRef = useRef(null);

    const navigate = useNavigate()
    const handleBajar = () => {
        if (continueButtonRef.current) {
            continueButtonRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const handleComprar = () => {
        navigate("/products/121-Kit%20de%20Arduino%20Básico")
    }

    const handleComprar2 = () => {
        navigate("/products/122-Kit%20de%20Arduino%20Ultimate")
    }
    
    
    const [selectedComponents, setSelectedComponents] = useState(
        Object.keys(componentes).reduce((acc, key) => ({ ...acc, [key]: true }), {})
    );

    const toggleComponent = (name) => {
        setSelectedComponents((prev) => ({
            ...prev,
            [name]: !prev[name],
        }));
    };

    const renderComponents = (items, isEditable = true, extraClass = "") => {
        return Object.keys(items).map((component, index) => (
            <div key={index} className={`item ${extraClass}`}>
                <div className="component-content">
                    <img src={items[component].image} alt={component} className="component-imag" />
                </div>
                <div className="component-bottom">
                    <p className="component-name">{component}</p>
                </div>
            </div>
        ));
    };

    return (
        <div>
            <Header/>
            <div className="image-conta">
                <div className="image-big">
                    <img src={"/images/KitsArduino.png"} alt="Rotating Animation Frame"/>
                </div>
                <h1 className="title">Kits de Arduino</h1>
                <h2>Una selección de componentes que brinda posibilidades infinitas</h2>
                <button className="order-btn" onClick={handleBajar}> Compra Ahora</button>
                <br/>
            </div>

            <h2>Componentes del Kit</h2>
            <p className="section-description">
                Componentes incluidos en ambas versiones del kit
            </p>
            <div className="grid">
                {renderComponents(componentes)}
            </div>

            <h2>Componentes Ultimate</h2>
            <p className="section-description">
                Componentes exclusivos de la versión Ultimate
            </p>
            <div className="content-grid">
                {renderComponents(componentesUltimate, false, "ultimate-frame")}
            </div>

            <h2>Sensores sorpresa</h2>
            <p className="section-description">
                Gracias al sensor sopresa tu kit es único, descubre las posibilidades (1 incluido por kit)
            </p>
            <div className="grid">
                {Object.keys(sorpresa).map((key, index) => (
                    <div key={index} className="sorpresa-item">
                        <img src={sorpresa[key]} alt={key} className="sorpresa-image"/>
                        <p className="sorpresa-name">{key}</p>
                    </div>
                ))}
            </div>

            <div className="KIT-info-container">
                <div className="KIT-content">
                    <div className="KIT-image-container">
                        <img src={'/images/KitsArduino.png'} alt="Microcontrolador ESP32" className="KIT-image"/>
                        <div className="KIT-dots-overlay"></div>
                    </div>
                    <div className="KIT-text-container">
                        <div className="KIT-text KIT-text-1">
                            Accede de forma ilimitada a material Digital
                        </div>
                        <div className="KIT-text KIT-text-2">
                            Llévalo al siguiente nivel con el Kit Ultimate
                        </div>
                        <div className="KIT-text KIT-text-5">
                            Componentes cuidadosamente seleccionados
                        </div>
                    </div>
                </div>
            </div>

            <div className="final-images">
                <div className="kit-final">
                    <img src={'/images/Ultimate.png'} alt="Kit Ultimate" className="final-image"/>
                    <p className="final-price">₡29950</p>
                    <button className="buy-btn" onClick={handleComprar2}> Compra Ahora</button>
                </div>

                <div className="kit-final">
                    <img src={'/images/basico.png'} alt="Kit Básico" className="final-image"/>
                    <p className="final-price">₡19950</p>
                    <button ref={continueButtonRef} className="buy-btn" onClick={handleComprar}> Compra Ahora</button>
                </div>
            </div>

            <Footer/>
        </div>
    );
};

export default KitsArduino;
